import React from "react";
import Skeleton from "react-loading-skeleton";

import ContentCardsSkeleton from "../../../Components/ContentCardsSkeleton/ContentCardsSkeleton";
import { LIBRARY_SECTIONS } from "../../../config/portalAluno/librarySections";
import "../page-skeleton.css";

const skeletonColors = {
  baseColor: "var(--portal-skeleton-base)",
  highlightColor: "var(--portal-skeleton-highlight)",
};

interface LibraryPageSkeletonProps {
  listing?: boolean;
}

const LibraryPageSkeleton = ({ listing = false }: LibraryPageSkeletonProps) => (
  <section
    className="content-page library-page"
    aria-label="Carregando Biblioteca"
    aria-busy="true"
  >
    <div className="library-page__inner portal-page-skeleton">
      {listing && (
        <Skeleton
          {...skeletonColors}
          borderRadius={7}
          className="portal-page-skeleton__back"
        />
      )}

      <header className="portal-page-skeleton__header">
        <Skeleton
          {...skeletonColors}
          borderRadius={8}
          className="portal-page-skeleton__page-title"
        />
        <Skeleton
          {...skeletonColors}
          borderRadius={6}
          className="portal-page-skeleton__description"
        />
      </header>

      {listing ? (
        <>
          <Skeleton
            {...skeletonColors}
            borderRadius={8}
            className="portal-page-skeleton__listing-title"
          />
          <ContentCardsSkeleton count={6} showTitle={false} />
        </>
      ) : (
        <div className="library-page__sections">
          {LIBRARY_SECTIONS.map((section) => (
            <section
              className="portal-page-skeleton__section"
              key={section.key}
              aria-hidden="true"
            >
              <div className="portal-page-skeleton__section-heading">
                <Skeleton
                  {...skeletonColors}
                  borderRadius={8}
                  className="portal-page-skeleton__section-title"
                />
                <Skeleton
                  {...skeletonColors}
                  borderRadius={7}
                  className="portal-page-skeleton__view-all"
                />
              </div>
              <ContentCardsSkeleton count={4} layout="row" showTitle={false} />
            </section>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default LibraryPageSkeleton;
